export default __webpack_public_path__ + "static/media/07.1efb24b0.png";